module.exports = __webpack_public_path__ + "img/noimage2.b604601e.jpg";